"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _util = require("../../util");

var _Detection = require("./Detection.styles");

var getFirstName = function getFirstName(fullname) {
  return fullname.split(/\s/)[0];
};

var Container = (0, _base["default"])("div", {
  target: "efi0w2p0",
  label: "Container"
})(_Detection.styles.detection, ";");

var Detection = function Detection(_ref) {
  var size = _ref.size,
      avatar = _ref.avatar,
      name = _ref.name,
      className = _ref.className,
      type = _ref.type,
      message = _ref.message;
  return (0, _jsxRuntime.jsxs)(Container, {
    type: type,
    size: size,
    className: className,
    hasAvatar: !!avatar,
    children: [(0, _jsxRuntime.jsx)("div", {
      css: _Detection.styles["".concat(size, "Avatar")],
      style: avatar && {
        backgroundImage: "url(".concat(avatar, ")")
      },
      children: !avatar && (0, _util.getNameInitials)(name)
    }), "".concat(getFirstName(name), " ").concat(message), (0, _jsxRuntime.jsx)("span", {
      css: _Detection.styles.dot,
      children: (0, _jsxRuntime.jsx)("span", {})
    })]
  });
};

Detection.propTypes = {
  size: (0, _propTypes.oneOf)(['big', 'small']),
  avatar: _propTypes.string,
  name: _propTypes.string,
  className: _propTypes.string,
  type: (0, _propTypes.oneOf)(['primary', 'secondary']),
  message: _propTypes.string
};
Detection.defaultProps = {
  size: 'big',
  avatar: undefined,
  name: '',
  className: undefined,
  type: 'primary',
  message: 'is replying'
};
var _default = Detection;
exports["default"] = _default;
//# sourceMappingURL=Detection.js.map